import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Button';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CheckIcon from '@material-ui/icons/CheckCircle';

export const statusTypes = {
  ERROR: 'ERROR',
  WARN: 'WARN',
  SUCCESS: 'SUCCESS',
  INFO: 'INFO',
};

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: theme.radius.md,
    padding: theme.spacing(2.5, 3),
    backgroundColor: theme.palette.common.white,
    maxWidth: theme.dimensions.md,
  },
  statusIconContainer: {
    padding: theme.spacing(1),
    borderRadius: '50%',
    marginRight: theme.spacing(2),
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: theme.spacing(4.5),
    width: theme.spacing(4.5),
  },
  errorIconContainer: {
    backgroundColor: theme.palette.facet.accentRed4,
    color: theme.palette.facet.red,
  },
  warnIconContainer: {
    backgroundColor: theme.palette.facet.accentYellow1,
    color: theme.palette.warning.main,
  },
  successIconContainer: {
    backgroundColor: theme.palette.facet.accentGreen6,
    color: theme.palette.success.main,
  },
  infoIconContainer: {
    backgroundColor: theme.palette.facet.accentBlue20,
    color: theme.palette.primary.main,
  },
  statusIcon: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },
  main: {
    overflow: 'hidden',
  },
  title: {
    color: theme.palette.facet.primaryGray,
    fontSize: theme.typography.h5.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  subtitle: {
    color: theme.palette.primary.main,
    fontSize: theme.typography.h3.fontSize,
    fontWeight: theme.typography.fontWeightExtraBold,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  endIconContainer: {
    flexShrink: 0,
  },
});

function StatusItem({
  title,
  subtitle,
  status,
  onClick,
  endIcon,
  className,
  classes,
  test,
}) {
  function handleClick() {
    if (onClick) onClick();
  }

  const StatusIcon = (() => {
    switch (status) {
      case statusTypes.ERROR:
      case statusTypes.WARN:
        return ErrorIcon;
      case statusTypes.SUCCESS:
        return CheckIcon;
      case statusTypes.INFO:
        return InfoIcon;
      default:
        return null;
    }
  })();

  const _innerContent = () => (
    <>
      {StatusIcon ? (
        <div className={classNames(classes.statusIconContainer, {
          [classes.errorIconContainer]: status === statusTypes.ERROR,
          [classes.warnIconContainer]: status === statusTypes.WARN,
          [classes.successIconContainer]: status === statusTypes.SUCCESS,
          [classes.infoIconContainer]: status === statusTypes.INFO,
        })}
        >
          <StatusIcon className={classes.statusIcon} />
        </div>
      ) : null}
      <div className={classes.main}>
        <Typography className={classes.title}>{title}</Typography>
        <Typography className={classes.subtitle}>{subtitle}</Typography>
      </div>
      <div className={classes.endIconContainer}>{endIcon}</div>

    </>
  );

  if (onClick) {
    return (
      <Button
        test={test}
        onClick={handleClick}
        className={classNames(classes.root, className)}
      >
        {_innerContent()}
      </Button>
    );
  }
  return (
    <div className={classNames(classes.root, className)} test={test}>
      {_innerContent()}
    </div>
  );
}
StatusItem.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  status: PropTypes.oneOf(Object.keys(statusTypes)),
  onClick: PropTypes.func,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  endIcon: PropTypes.object,
  test: PropTypes.string,
};
StatusItem.defaultProps = {
  status: undefined,
  subtitle: undefined,
  onClick: undefined,
  className: undefined,
  endIcon: undefined,
  test: undefined,
};

export default withStyles(styles)(StatusItem);
